module.exports=function(e){var t={};function r(o){if(t[o])return t[o].exports;var n=t[o]={i:o,l:!1,exports:{}};return e[o].call(n.exports,n,n.exports,r),n.l=!0,n.exports}return r.m=e,r.c=t,r.d=function(e,t,o){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:o})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(r.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var n in e)r.d(o,n,function(t){return e[t]}.bind(null,n));return o},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=74)}({1:function(e,t){e.exports=require("react")},2:function(e,t){e.exports=require("styled-components")},3:function(e,t){e.exports=require("../../styles")},5:function(e,t){e.exports=require("../Icon/Icon")},74:function(e,t,r){"use strict";var o=this&&this.__createBinding||(Object.create?function(e,t,r,o){void 0===o&&(o=r),Object.defineProperty(e,o,{enumerable:!0,get:function(){return t[r]}})}:function(e,t,r,o){void 0===o&&(o=r),e[o]=t[r]}),n=this&&this.__setModuleDefault||(Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t}),a=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var r in e)"default"!==r&&Object.hasOwnProperty.call(e,r)&&o(t,e,r);return n(t,e),t},i=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const u=a(r(1)),s=i(r(2)),l=i(r(75)),d=i(r(76)),c=r(3),f=i(r(5)),{KineduPalette:p}=c.colorPalettes,b=s.default.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  .search-text {
    input {
      border-radius: 0px;
      height: 48px;
      border: none;
    }
  }

  .search-btn {
    display: none;
    position: absolute;
    right: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  &.focused {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;

    .search-text {
      box-shadow: 0 1px 8px -6px;
    }

    .search-suggestions {
      display: flex;
    }
  }

  ${c.breakPoints.desktop} {
    .search-text {
      input {
        height: 40px;
        border-radius: 20px;
        border: 1px solid #ACC2D3;
      }
    }
    .search-btn {
      display: block;
    }

    .search-icon {
      display: none;
    }

    &.focused {
      position: relative;

      .search-text {
        box-shadow: none;

        input {
          border-radius: 0;
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;

          & + .texter-slot .search-btn {
            border-radius: 0;
            border-top-right-radius: 20px;
          }
        }
      }

      .search-suggestions {
        display: flex;
      }
    }
  }
`,h=s.default.div.attrs(()=>({className:"row"}))`
  display: flex;
  width: 100%;

  .search-icon {
    margin-top: -5px;
  }
`,x=s.default(h)`

  ${c.breakPoints.desktop} {
    z-index: 1;
    position: absolute;
    top: 100%;
  }
`,m=s.default.div`
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;

  padding-top: 70px;
  width: 100%;
  background-color: white;

  ${c.breakPoints.desktop} {
    position: relative;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    padding-top: 0px;
    border: 1px solid ${p.shadeMedium};
    border-top: none;
    box-shadow: 0 5px 10px 0 rgba(0,0,0,0.20);
  }
`;t.default=e=>{const{onSearch:t=(()=>{}),placeholder:r="What are you looking for...",suggestionsSlot:o=(()=>null),handleIsOpen:n,closeSearch:a,value:i,onChangeText:s,buttonText:c="Search"}=e,[g,v]=u.useState(i),y=u.useRef(),_=u.useRef();u.useEffect(()=>{v(i)},[i]);const O=()=>{y.current.classList.remove("focused"),n(!1)},P=e=>{y.current&&!y.current.contains(e.target)&&O()},j=()=>{t(_.current.value)};return u.useEffect(()=>(document.addEventListener("mousedown",P),()=>{document.removeEventListener("mousedown",P)}),[]),u.useEffect(()=>{a&&O()},[a]),u.default.createElement(b,{className:"lego-searcher",ref:y},u.default.createElement(h,null,u.default.createElement(l.default,{getInputRef:e=>{_.current=e},value:g,onChange:s,className:"search-text",theme:"RoundedFlat",name:"Search",placeholder:r,onFocus:()=>{y.current.classList.add("focused"),n(!0)},rightSlot:()=>u.default.createElement(u.default.Fragment,null,u.default.createElement(d.default,{className:"search-btn",color:p.newKinedu,flat:!0,rounded:!0,small:!0,onClick:j},c),u.default.createElement(f.default,{className:"search-icon",color:p.newKinedu,name:"lens",onClick:j,size:30}))})),u.default.createElement(x,null,u.default.createElement(m,{className:"search-suggestions"},o())))}},75:function(e,t){e.exports=require("../Texter/Texter")},76:function(e,t){e.exports=require("../Button/Button")}});